module.exports = __webpack_public_path__ + "img/three.d1be3064.png";